import React, { Component } from "react";
import styled from "styled-components";

import {
  institutionsName,
  institutionsType,
} from "@/database/institutions.json";

const Div = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .text-title {
    color: white;

    .name {
      font-size: 3rem;
      padding: 3rem 0 1rem 0;
    }

    .type {
      font-size: 3rem;
      font-weight: lighter;
    }
  }

  .text-foot {
    color: white;
    font-size: 1.4rem;
  }
`;

class SignUpTitle extends Component {
  render() {
    return (
      <Div>
        <div className="text-title">
          <div className="name">{institutionsName}</div>
          <div className="type">{institutionsType}</div>
        </div>
        <div className="text-foot">
          {institutionsName + institutionsType} 鲁ICP备14014132号-2
          <br />
          本系统由设计院网提供技术支持
        </div>
      </Div>
    );
  }
}

export default SignUpTitle;
